import React, { useEffect, useRef, useState } from "react";
import OtherHousesIcon from "@mui/icons-material/OtherHouses";
import AppStandardButton from "../../components/UI/AppButtons";
import BookingGetters from "../../store/onlineBooking/getters";
import theme, { formatTheme } from "../../config/MuiColorThemes";
import { createTheme } from "@mui/material/styles";
import { ReservationDetailsPreview } from "../../components/Layouts/ReservationDetailsPreview/ReservationDetailsPreview";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import {
  AllPaymentMethodsResponse,
  PaymentBody,
} from "../../@types/DTO/AllPaymentMethods";
import { PayPal } from "../../components/Layouts/PaymentForms/PayPal";
import { StripeEmbeddedPayment } from "../../components/Layouts/PaymentForms/StripeEmbeddedPayment";
import { createSearchParams, useNavigate } from "react-router-dom";
import BookingApi from "../../API/Apis/BookingApi";
import { Vehicle } from "../../@types/DTO/Vehicles";
import { SelectedVehicleDetails } from "../../@types/Booking/SelectedVehicleDetails";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import PersonalDetails from "./PersonalDetails";
import NewPersonalDetails from "./NewPersonalDetails";
import CompanyDetails from "./CompanyDetails";
import NewCompanyDetails from "./NewCompanyDetails";
import TermsAndConditions from "./TermsAndConditions";
import AlertMessage from "../AlertMessage";
import i18n, { t } from "i18next";
import { AppRadioButton } from "../../components/UI/AppRadioButtons/AppRadioButtons";
import AppButton from "../../components/UI/AppButtons";
import { PrivacyPolicy } from "../../@types/DTO/privacyPolicy";
import { BOOKING_ACTIONS } from "../../store/onlineBooking";
import { useDispatch } from "react-redux";
import GretaHeader from "../../components/Layouts/AppHeader/GretaHeader";

function PaymentDetailsPage({
  reservationSourcePayNow,
  reservationSourcePayLater,
  updateVehiclePrice,
  updateSelectedPrice,
  allPayNowMethods,
  allPayLaterMethods,
  updateActiveStep,
  isAirport,
  showScalapayWidgetPayLater,
  showScalapayWidgetPayNow,
  scalapayMerchantToken,
  scalapayEnvVal,
  localeScalapay,
  paymentType,
  onPaymentTypeChange,
  updateVehiclePriceLater,
  onBack,
}) {
  const isEnableNewPayPalConfiguration =
    (Array.isArray(allPayNowMethods?.paypal) &&
      allPayNowMethods.paypal[0]?.enableNewPayPalConfiguration) ||
    (Array.isArray(allPayLaterMethods?.paypal) &&
      allPayLaterMethods.paypal[0]?.enableNewPayPalConfiguration);

  const { t: translate } = useTranslation();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [searchParams] = useSearchParams();
  const scriptChannel = searchParams.get("scriptChannel") ?? "";
  const resSourcePayLater =
    searchParams.get("reservationSourcePayLater") === "true";
  const isReservedAreaUser =
    !!localStorage.getItem("userID") &&
    !!BookingGetters.getAppSettings()?.enableOnlyWireTransferForResArea;
  const [typePayment, setTypePayment] = useState<"payNow" | "payLater">(
    isReservedAreaUser ? "payLater" : resSourcePayLater ? "payLater" : "payNow"
  );
  const [payLaterLabelText, setPayLaterLabelText] = useState<String>("");
  const [showBillingDetails, setShowBillingDetails] = useState<boolean>(false);
  const [showPriceDetail, setShowPriceDetail] = useState(false);
  const [recapExpanded, setRecapExpanded] = useState(false);
  const [handleBillingHeight, setHandleBillingHeight] =
    useState<boolean>(false);

  const [paymentTypeCompanyDetails, setPaymentTypeCompanyDetails] =
    useState(typePayment);
  useEffect(() => {
    const type = !scriptChannel
      ? resSourcePayLater
        ? "payLater"
        : typePayment
      : typePayment;
    setPaymentTypeCompanyDetails(type);
  }, [typePayment]);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [invalidError, setInvalidError] = useState("");
  const [dateError, setDateError] = useState("");
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const privateValidateRef = useRef<(() => boolean) | null>(null);
  const companyValidateRef = useRef<(() => Promise<boolean>) | null>(null);
  const stripeFormRef = useRef<HTMLDivElement>(null);
  const stripeConfirmUrlRef = useRef<string>("");
  const updateUserPrimaryDetails = (key, value) => {
    if (key == "firstName") {
      setFirstName(value);
    } else if (key == "lastName") {
      setLastName(value);
    } else if (key == "email") {
      setEmail(value);
      setEmailError("");
    } else if (key == "telephone") {
      setPhoneNo(value);
      setPhoneError("");
    }
  };
  const dispatch = useDispatch();
  useEffect(() => {
    if (firstName && lastName && email) {
      dispatch(
        BOOKING_ACTIONS.setCustomerPrimaryDetails({
          firstName,
          lastName,
          email,
          telephone: phoneNo,
        })
      );
    }
  }, [firstName, lastName, email, phoneNo]);
  const [companyinvoiceDetails, setCompanyinvoiceDetails] = useState<any>([]);
  const currentLoggedInuser: string | undefined =
    localStorage.getItem("userID") || undefined;
  const navigateTo = useNavigate();
  const lang = i18n.language;
  const payPalFormRef = useRef<HTMLFormElement>();
  const AppSettings = BookingGetters.getAppSettings();
  const [checked, setChecked] = React.useState(false);
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
  const [termsError, setTermsError] = useState<string>("");
  const termsRef = useRef<HTMLDivElement>(null);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };
  const ReservationDetails = BookingGetters.getBookingDetails();
  const [ReservationId, setReservationId] = useState<number>(0);
  const VehicleDetails = BookingGetters.getSelectedVehicleDetails();
  const [extrasSelected, setExtrasSelected] = useState<SelectedVehicleDetails>(
    []
  );
  const [userId] = useState(localStorage.getItem("userID"));
  useEffect(() => {
    setExtrasSelected(VehicleDetails.paymentDetails);
  }, []);
  const UserDetails = BookingGetters.getUserDetails();
  const [whetherIfGroupIsOnRequest, setWhetherIfGroupIsOnRequest] =
    useState<string>("false");
  useEffect(() => {
    if (VehicleDetails.vehicleDetails?.Status.toLowerCase() == "onrequest") {
      setWhetherIfGroupIsOnRequest("true");
    } else setWhetherIfGroupIsOnRequest("false");
  });
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const [paypalBody, setPaypalBody] = useState<string | undefined>();
  const [stripeBody, setStripeBody] = useState<string | undefined>();
  const [nexiBody, setNexiBody] = useState<string | undefined>();
  const [datatransBody, setDatatransBody] = useState<string | undefined>();

  const [stripeEmbeddedOpen, setStripeEmbeddedOpen] = useState(false);
  const [stripeClientSecret, setStripeClientSecret] = useState<string>("");
  const [stripeReservationDbId, setStripeReservationDbId] = useState<number>(0);
  const [stripePaymentSuccess, setStripePaymentSuccess] = useState(false);
  const [stripePublishableKey, setStripePublishableKey] = useState<string>("");
  const [stripeChargeOrDep, setStripeChargeOrDep] = useState<"C" | "D">("C");
  const [stripePriceId, setStripePriceId] = useState<string>("");
  const [stripeDisplayAmount, setStripeDisplayAmount] = useState<number>(0);

  // ──────────────────────────────────────────────────────────────────────────
  const [scalapayBody, setScalapayBody] = useState<string | undefined>();
  const [customerBlacklistMessageBody, setcustomerBlacklistMessageBody] =
    useState<string | undefined>();
  const [bookingPaymentSubDescData, setBookingPaymentSubDescData] = useState<
    string | undefined
  >();
  const [invalidTaxCodeBody, setInvalidTaxCodeBody] = useState<
    string | undefined
  >();
  const [priceDetailsText, setPriceDetailsText] = useState<string>("");
  const [reviewBookingText, setReviewBookingText] = useState<string>("");
  const [rentalCostsText, setRentalCostsText] = useState<string>("");
  const [personalDetailsErrorText, setPersonalDetailsErrorText] = useState<any>(
    { firstName: "", lastName: "", email: "", telephone: "" }
  );

  const [cancellationPolicyMsg, setCancellationPolicyMsg] = useState<
    string | undefined
  >();
  const id: any = localStorage.getItem("userID");
  useEffect(() => {
    const fetchTextResources = async () => {
      const [
        PayPalPayLabelObject,
        stripePayLabelObject,
        nexiPayLabelObject,
        datatransPayLabelObject,
        scalapayLabelObject,
        customerBlacklistMessageObject,
        invalidTaxCodeObject,
        cancellationPolicyObject,
      ] = [
        "PayPalPayLabel",
        "stripePayLabel",
        "nexiPayLabel",
        "datatransPayLabel",
        "scalapayPayLabel",
        "customer_blacklist_message",
        "invalidTaxCodeMessage",
        "cancellationPolicyMessage",
      ].map((key) => data.find((item) => item?.key === key));
      const payLaterLabelData = data.find(
        (item) => item.key === "SurchargeText"
      );
      setPayLaterLabelText(payLaterLabelData?.body || "");
      setPaypalBody(PayPalPayLabelObject?.body);
      setStripeBody(stripePayLabelObject?.body);
      setNexiBody(nexiPayLabelObject?.body);
      setDatatransBody(datatransPayLabelObject?.body);
      setScalapayBody(scalapayLabelObject?.body);
      setcustomerBlacklistMessageBody(customerBlacklistMessageObject?.body);
      setBookingPaymentSubDescData(
        data.find((item) => item.key === "PaymentSubDescLabel")?.body
      );
      setInvalidTaxCodeBody(invalidTaxCodeObject?.body);
      setCancellationPolicyMsg(cancellationPolicyObject?.body);
      setPriceDetailsText(
        data.find((item) => item.key === "Price details")?.body ||
          translate("Price details")
      );
      setReviewBookingText(
        data.find((item) => item.key === "reviewBooking")?.body ||
          translate("Review Booking")
      );
      setRentalCostsText(
        data.find((item) => item.key === "rentalCostsLabel")?.body ||
          translate("Rental costs")
      );
    };
    fetchTextResources();
  }, [lang, textResource, translate]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<string>("");
  // ****************************** mode of payment logic **********************************
  const [allNewPaymentMethods, setAllNewPaymentMethods] = useState<
    Partial<AllPaymentMethodsResponse>
  >({});
  const showCreditCardDeferredPayment =
    AppSettings?.showCreditCardDeferredPayment;
  const [enableCreditCardDeferredPayment, setEnableCreditCardDeferredPayment] =
    useState(false);

  const getPreferredMethod = (
    methods: Record<string, any>,
    mode: "payLater" | "payNow"
  ) => {
    const keys = Object.keys(methods || {});
    if (keys.length === 0) return null;

    if (keys.length === 1) return keys[0];

    if (mode === "payLater") {
      const wire = keys.find((k) => k.toLowerCase() === "wiretransfer");
      if (wire) return wire;

      const nexi = keys.find((k) => k.toLowerCase() === "nexi");
      if (nexi) return nexi;
    }

    if (mode === "payNow") {
      const nexi = keys.find((k) => k.toLowerCase() === "nexi");
      if (nexi) return nexi;
    }

    return keys[0];
  };
  const [customerDetails, setCustomerDetails] = useState<any>(null);

  // useEffect(() => {
  //   const customerId = localStorage.getItem("customerId");
  //   if (
  //     userId != null &&
  //     userId !== "null" &&
  //     userId !== "" &&
  //     customerId != null &&
  //     customerId !== "null" &&
  //     customerId !== ""
  //   ) {
  //     BookingApi.getCustomerDetails(parseInt(customerId)).then((res) => {
  //       const customer = res.data;
  //       setFirstName(customer?.firstName || "");
  //       setLastName(customer?.lastName || "");
  //       setEmail(customer?.email || "");
  //       setPhoneNo(customer?.mobileNumber || "");
  //       setCustomerDetails(customer);
  //     });
  //   }
  // }, [userId]);

  useEffect(() => {
    const isPayLater =
      (typePayment === "payLater" &&
        VehicleDetails.paymentDetails?.type?.toUpperCase() === "PAYLATER") ||
      reservationSourcePayLater === "true";

    const isPayNow =
      typePayment === "payNow" &&
      VehicleDetails.paymentDetails?.type?.toUpperCase() === "PAYNOW";

    const methodsBasedOnSelection = isPayLater
      ? allPayLaterMethods
      : allPayNowMethods;

    setAllNewPaymentMethods(methodsBasedOnSelection);

    const preferredMethod = getPreferredMethod(
      methodsBasedOnSelection,
      isPayLater ? "payLater" : "payNow"
    );

    if (preferredMethod) {
      setSelectedPaymentMethod(preferredMethod.toUpperCase());
    }

    if (
      showCreditCardDeferredPayment &&
      methodsBasedOnSelection?.creditCardDeferred
    ) {
      setSelectedPaymentMethod("WIRETRANSFER");
      setEnableCreditCardDeferredPayment(true);
    } else {
      setEnableCreditCardDeferredPayment(false);
    }

    if (isReservedAreaUser) {
      // enableOnlyWireTransferForResArea = true + logged in → always wiretransfer
      const methodKeys = Object.keys(methodsBasedOnSelection || {});
      const wire = methodKeys.find((k) => k.toLowerCase() === "wiretransfer");
      if (wire) {
        setSelectedPaymentMethod(wire);
        return;
      }
      setSelectedPaymentMethod(methodKeys[0]);
      return;
    } else if (currentLoggedInuser) {
      const methodKeys = Object.keys(methodsBasedOnSelection || {});
      if (isPayLater) {
        const wire = methodKeys.find((k) => k.toLowerCase() === "wiretransfer");
        if (wire) {
          setSelectedPaymentMethod(wire);
          return;
        }

        const nexi = methodKeys.find((k) => k.toLowerCase() === "nexi");
        if (nexi) {
          setSelectedPaymentMethod(nexi);
          return;
        }

        setSelectedPaymentMethod(methodKeys[0]);
        return;
      }

      if (isPayNow) {
        const nexi = methodKeys.find((k) => k.toLowerCase() === "nexi");
        if (nexi) {
          setSelectedPaymentMethod(nexi);
          return;
        }

        setSelectedPaymentMethod(methodKeys[0]);
        return;
      }
    }
  }, [
    typePayment,
    allPayLaterMethods,
    allPayNowMethods,
    reservationSourcePayLater,
    showCreditCardDeferredPayment,
    currentLoggedInuser,
    VehicleDetails.paymentDetails?.type,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!VehicleDetails?.paymentDetails?.price) {
        navigateTo("/");
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  createSearchParams({
    dropOffDateAndTime: new Date(ReservationDetails.dropOffDateAndTime)
      .getTime()
      .toString(),
    pickUpDateAndTime: new Date(ReservationDetails.pickUpDateAndTime)
      .getTime()
      .toString(),
    pickUpLocation: ReservationDetails.pickUpLocationDetails.code,
    dropOffLocation: ReservationDetails.dropOffLocationDetails.code,
    reservationSource: ReservationDetails.reservationSource.code,
    macroGroupName: ReservationDetails.macroGroupName,
    discountValueWithoutVat: ReservationDetails.discountValueWithoutVat,
    agreementCoupon: ReservationDetails.agreementCoupon,
    showPics: "true",
    showOptionalImage: "true",
    showVehicleParameter: "true",
    showVehicleExtraImage: "true",
    showBookingDiscount: "true",
    isYoungDriverAge: ReservationDetails.isYoungDriverAge,
    isYoungDriver2Age: ReservationDetails.isYoungDriver2Age,
    isSeniorDriverAge: ReservationDetails.isSeniorDriverAge,
    noFeeAge: ReservationDetails.noFeeAge,
  }).toString();

  // ******************************   new features added for rentalplus **********************************
  const [userType, setUserType] = useState("Private");
  const handleUserType = (userType: string) => {
    setUserType(userType);
  };
  useEffect(() => {
    requestParentResize(checked, handleBillingHeight);
  }, [checked, userType, handleBillingHeight]);
  const extraPaymentIFrameMobile =
    Number(AppSettings?.iframeHeightPaymentPageForMobile) || 0;
  const extraPaymentIFrameDesktop =
    Number(AppSettings?.iframeHeightForPaymentPage) || 0;
  //below code is for iframe mainly for mobile view
  const paymentFormRef = useRef<HTMLDivElement>(null);

  // const recapHeight = isExpanded1
  //   ? 377
  //   : isExpanded2
  //   ? 361
  //   : isExpanded3
  //   ? 371
  //   : isExpanded4
  //   ? 349
  //   : 221;

  function requestParentResize(
    checked: boolean,
    billingVisible: boolean = handleBillingHeight
  ) {
    let iframeHeight;

    const isCompany = userType === "Company";
    const isPrivate = userType === "Private";
    const isIndividual = userType === "Individual";

    const isEmptyUserType =
      !userType || (typeof userType === "string" && userType.trim() === "");
    const showPayNow =
      reservationSourcePayNow === "true" && showScalapayWidgetPayNow;

    const showPayLater =
      reservationSourcePayLater === "true" && showScalapayWidgetPayLater;
    const hideFields =
      AppSettings?.hideNumberOfFieldsAtPayNow ||
      AppSettings?.hideNumberOfFieldsAtPayAtDesk;

    if (checked) {
      iframeHeight = isCompany
        ? isSmallScreen
          ? 4517
          : 2260
        : isSmallScreen
        ? 5189
        : 2508;
    } else {
      if (isCompany) {
        if (AppSettings?.showOnePayMethodTwoPrice) {
          iframeHeight = isSmallScreen ? 3600 : 2000;
        } else if (hideFields && !billingVisible) {
          iframeHeight = isSmallScreen ? 4000 : 2250;
        } else {
          iframeHeight = isSmallScreen ? 3920 : 2200;
        }
      } else if (isPrivate) {
        if (AppSettings?.showOnePayMethodTwoPrice) {
          iframeHeight = isSmallScreen ? 3700 : 2100;
        } else if (hideFields && !billingVisible) {
          iframeHeight = isSmallScreen ? 4090 : 2350;
        } else {
          iframeHeight = isSmallScreen ? 4020 : 2300;
        }
      } else if (isIndividual) {
        if (AppSettings?.showOnePayMethodTwoPrice) {
          iframeHeight = isSmallScreen ? 4300 : 2300;
        } else {
          iframeHeight =
            hideFields && !billingVisible
              ? isSmallScreen
                ? 4680
                : 2540
              : isSmallScreen
              ? 4600
              : 2490;
        }
      } else {
        // EMPTY USER TYPE
        if (AppSettings?.showOnePayMethodTwoPrice) {
          iframeHeight = isSmallScreen ? 2080 : 1380;
        } else if (showPayNow || showPayLater) {
          iframeHeight = isSmallScreen ? 2080 : 1380;
        } else if (hideFields && billingVisible && isEmptyUserType) {
          iframeHeight = isSmallScreen ? 2400 : 1500;
        } else if (!billingVisible && isEmptyUserType) {
          iframeHeight = isSmallScreen ? 2850 : 1830;
        } else if (billingVisible && isEmptyUserType) {
          iframeHeight = isSmallScreen ? 4280 : 1700;
        } else {
          iframeHeight = isSmallScreen ? 4280 : 2400;
        }
      }
    }

    // EXTRA HEIGHT
    if (isEmptyUserType && billingVisible) {
      iframeHeight += isSmallScreen ? 250 : 200;
    }

    iframeHeight += isSmallScreen
      ? extraPaymentIFrameMobile
      : extraPaymentIFrameDesktop;

    const extraheightforDesktop = showPayNow || showPayLater ? 180 : 0;
    const extraheightforMobile = showPayNow || showPayLater ? 370 : 70;

    iframeHeight += isSmallScreen
      ? extraPaymentIFrameMobile + extraheightforMobile
      : extraPaymentIFrameDesktop + extraheightforDesktop;
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: { iframeHeight },
      },
      "*"
    );
  }

  const appSettings = BookingGetters.getAppSettings();

  const [selectedPrivacyPolicy, setSelectedPrivacyPolicy] = useState<string[]>(
    []
  );
  const [requiredPolicy, setRequiredPrivacyPolicy] = useState<string[]>([]);
  const [allPrivacyPolicy, setAllPrivacyPolicy] = useState<
    PrivacyPolicy["privacyPolicy"]
  >([]);
  useEffect(() => {
    if (AppSettings?.showMyRentPolicies) {
      BookingApi.getPrivacyPolicy(null, "booking").then((response) => {
        const fetchedPolicies = response.data.privacyPolicy.map((item) => {
          const policyGroup = item.policyGroup;
          return policyGroup;
        });
        setAllPrivacyPolicy(fetchedPolicies);

        const getPolicies = (condition) =>
          fetchedPolicies.flatMap((policyArray) =>
            policyArray
              .filter(condition)
              .map((policy) =>
                i18n.language === "it"
                  ? policy.privacyPolicyLocalLang
                  : policy.privacyPolicyEn
              )
          );
        setSelectedPrivacyPolicy(
          getPolicies((policy) => policy.isDefaultAccepted)
        );
        setRequiredPrivacyPolicy(getPolicies((policy) => policy.isMandatory));
        setRequiredPrivacyPolicy(requiredPolicy);
      });
    }
  }, []);
  const countryList = AppSettings?.config.country;

  const updateSelectedPrivacyPolicy = (index, value) => {
    setSelectedPrivacyPolicy((prev) => {
      prev[index] = value;
      return [...prev];
    });
  };
  const [currentPriceToPay, setCurrentPriceToPay] = useState(0);
  const [localSelectedPrice, setLocalSelectedPrice] = useState(0);
  const handleUpdateSelectedPrice = (price) => {
    setLocalSelectedPrice(parseFloat(price) || 0);
    updateSelectedPrice(price);
  };
  const [percentageAmtOfExtras] = useState(
    AppSettings?.percentageAmountForExtras
  );
  const [percentOnAmount] = useState(AppSettings?.percentOnAmount);
  const [percentOnPayLaterAmount] = useState(
    AppSettings?.percentOnPayLaterAmount
  );
  const payType = VehicleDetails.paymentDetails?.type;

  useEffect(() => {
    const price = VehicleDetails?.paymentDetails?.price;
    if (percentOnAmount != null && (payType == "PAYNOW" || payType == "")) {
      let totalPrice = price;

      if (!VehicleDetails?.paymentDetails?.extrasIncluded) {
        totalPrice += extrasSelected?.extrasPrice;
      }

      const updatedPrice =
        (totalPrice ? totalPrice * percentOnAmount : 0) / 100;

      setCurrentPriceToPay(updatedPrice);
    } else if (percentOnPayLaterAmount != null && payType == "PAYLATER") {
      let totalPrice = price;

      if (!VehicleDetails?.paymentDetails?.extrasIncluded) {
        totalPrice += extrasSelected?.extrasPrice;
      }

      /* ----------- SURCHARGE LOGIC ADDED ----------- */
      let surchargeAmount = 0;

      const surchargePercent =
        VehicleDetails?.vehicleDetails?.Vehicle?.payLaterSurcharge ?? undefined;
      if (surchargePercent !== undefined) {
        surchargeAmount = (totalPrice * surchargePercent) / 100;
        totalPrice += surchargeAmount;
      }
      /* ----------- END SURCHARGE LOGIC ----------- */

      const updatedPrice =
        (totalPrice ? totalPrice * percentOnPayLaterAmount : 0) / 100;
      setCurrentPriceToPay(updatedPrice);
    } else if (percentageAmtOfExtras != null && price != null && price > 0) {
      // logic added to set how much % of extras & insurance amount customer will pay at the time of creating booking
      if (VehicleDetails?.paymentDetails?.extrasIncluded) {
        setCurrentPriceToPay(
          (extrasSelected?.extrasPrice *
            parseFloat(percentageAmtOfExtras.toString())) /
            100 +
            parseFloat(price.toString()) -
            extrasSelected?.extrasPrice
        );
      } else {
        setCurrentPriceToPay(
          (extrasSelected?.extrasPrice *
            parseFloat(percentageAmtOfExtras.toString())) /
            100 +
            parseFloat(price.toString())
        );
      }
    } else if (VehicleDetails?.paymentDetails?.price != null) {
      if (VehicleDetails?.paymentDetails?.extrasIncluded) {
        setCurrentPriceToPay(VehicleDetails?.paymentDetails?.price);
      } else {
        setCurrentPriceToPay(
          VehicleDetails?.paymentDetails?.price + extrasSelected?.extrasPrice
        );
      }
    }
  }, [
    percentageAmtOfExtras,
    VehicleDetails?.paymentDetails,
    extrasSelected,
    payType,
  ]);

  const [loading, setLoading] = useState(false);
  const blurScreen = () => {
    document.body.style.opacity = String(0.5);
    document.body.style.pointerEvents = "none";
  };
  useEffect(() => {
    if (loading) {
      blurScreen();
    } else {
      document.body.style.opacity = String(1);
      document.body.style.pointerEvents = "";
    }
  }, [loading]);

  useEffect(() => {
    if (stripeEmbeddedOpen && stripeFormRef.current) {
      stripeFormRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [stripeEmbeddedOpen]);

  useEffect(() => {
    if (!stripePaymentSuccess) return;
    const timer = setTimeout(() => {
      navigateTo(stripeConfirmUrlRef.current);
    }, 2500);
    return () => clearTimeout(timer);
  }, [stripePaymentSuccess]);

  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isCloseButton, setIsCloseButton] = useState(false);

  const onRequestClose = () => {
    setOpenModal(false);
    setModalMessage("");
    if (isCloseButton == true) {
      updateActiveStep();
    }
  };

  const novehicleModal = (msg) => {
    setModalMessage(msg);
    setOpenModal(true);
    setIsCloseButton(true);
  };
  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      "*"
    );
  };
  const isSmallScreen = window.innerWidth <= 768;
  const isTabletScreen = window.innerWidth <= 1024;

  const isHidePayCounterRadio = AppSettings?.hidePayAtCounterRadioButton;
  const hideNumberOfFieldsAtPayAtDesk =
    AppSettings?.hideNumberOfFieldsAtPayAtDesk ?? false;

  const isResSoucePayNow =
    searchParams.get("reservationSourcePayNow") === "true";
  const restrictBlacklistCustomersFromBooking =
    AppSettings?.restrictBlacklistCustomersFromBooking;

  const focusFieldByKey = (key: string): void => {
    const input = paymentFormRef.current?.querySelector<HTMLInputElement>(
      `[data-field-key="${key}"] input`
    );
    if (input) {
      input.scrollIntoView({ behavior: "smooth", block: "center" });
      input.focus();
    }
  };

  const validateTerms = (): boolean => {
    if (!termsAccepted) {
      setTermsError(t("This is a required field"));
      termsRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      const termsInput =
        termsRef.current?.querySelector<HTMLInputElement>("input");
      termsInput?.focus();
      return false;
    }

    // Mandatory MyRent privacy policies must all be selected before booking.
    if (AppSettings?.showMyRentPolicies && requiredPolicy?.length) {
      const strip = (v: string) => (v?.startsWith("*") ? v.slice(1) : v);
      const selected = ((selectedPrivacyPolicy as any[]) || [])
        .flat(Infinity)
        .map(strip);
      if (!requiredPolicy.every((p) => selected.includes(strip(p)))) {
        setTermsError(t("This is a required field"));
        termsRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        return false;
      }
    }

    setTermsError("");
    return true;
  };

  // Legacy payment form (showOldPaymentForm): lighter gate — enforce the Country
  // field when it is configured mandatory in MyRent.
  const validateOldPaymentForm = async (): Promise<boolean> => {
    if (AppSettings?.countryRequired && !UserDetails?.country) {
      setInvalidError(`${t("Country")} ${t("is required")}`);
      focusFieldByKey("country");
      return false;
    }
    setInvalidError("");
    return validateTerms();
  };

  const validatePaymentForm = async (): Promise<boolean> => {
    if (AppSettings?.showOldPaymentForm) {
      return await validateOldPaymentForm();
    }

    const requiredMsg = (labelKey: string): string =>
      `${t(labelKey)} ${t("is required")}`;
    const personalErrors = {
      firstName: "",
      lastName: "",
      email: "",
      telephone: "",
    };

    if (!String(firstName || "").trim()) {
      personalErrors.firstName = requiredMsg("First Name");
    }
    if (!String(lastName || "").trim()) {
      personalErrors.lastName = requiredMsg("Last Name");
    }
    if (!String(email || "").trim()) {
      personalErrors.email = requiredMsg("Email");
    } else if (!isValidEmail(email)) {
      personalErrors.email = t("Please provide a valid email");
    }
    if (
      AppSettings?.markPhoneNoRequiredForPrivate &&
      String(phoneNo || "").replace(/\D/g, "").length <= 4
    ) {
      personalErrors.telephone = requiredMsg("Phone");
    }
    if (Object.values(personalErrors).some(Boolean)) {
      setPersonalDetailsErrorText(personalErrors);
      setEmailError(personalErrors.email);
      setPhoneError(personalErrors.telephone);
      return false;
    }
    setPersonalDetailsErrorText({
      firstName: "",
      lastName: "",
      email: "",
      telephone: "",
    });
    setEmailError("");
    setPhoneError("");

    setDateError("");
    setInvalidError("");
    if (userType === "Private" && privateValidateRef.current) {
      const ok = await privateValidateRef.current();
      if (!ok) return false;
    } else if (
      (userType === "Company" || userType === "Individual") &&
      companyValidateRef.current
    ) {
      const ok = await companyValidateRef.current();
      if (!ok) return false;
    }

    return validateTerms();
  };

  useEffect(() => {
    if (
      (paymentType &&
        paymentType == "payLater" &&
        scriptChannel &&
        hideNumberOfFieldsAtPayAtDesk) ||
      (!scriptChannel &&
        reservationSourcePayLater == "true" &&
        hideNumberOfFieldsAtPayAtDesk)
    ) {
      setUserType("");
    } else if (paymentType && paymentType == "payNow" && scriptChannel) {
      setUserType("Private");
    } else if (
      hideNumberOfFieldsAtPayAtDesk &&
      AppSettings?.showOnePayMethodTwoPrice &&
      !isResSoucePayNow
    ) {
      setUserType("");
    }
  }, [paymentType]);

  // const typeOfUser = userType === "Company" ? "Company" : "INDIVIDUAL";
  // const userData = {
  //   ...UserDetails,
  //   customerType: typeOfUser.toUpperCase(),
  // };
  const showByPaymentType =
    paymentType === "payNow"
      ? showScalapayWidgetPayNow === true
      : paymentType === "payLater"
      ? showScalapayWidgetPayLater === true
      : false;

  const showForScriptChannel =
    (scriptChannel &&
      ((paymentType == "payNow" && showScalapayWidgetPayNow) ||
        (paymentType == "payLater" && showScalapayWidgetPayLater))) ||
    (!scriptChannel &&
      ((reservationSourcePayNow == "true" && showScalapayWidgetPayNow) ||
        (reservationSourcePayLater == "true" && showScalapayWidgetPayLater)));

  const showForNonScriptChannel =
    scriptChannel == "" &&
    reservationSourcePayNow === "false" &&
    reservationSourcePayLater === "false" &&
    (showScalapayWidgetPayNow === true || showScalapayWidgetPayLater === true);

  const shouldShowScalapayWidget =
    !isReservedAreaUser &&
    showByPaymentType &&
    (showForScriptChannel || showForNonScriptChannel);
  showByPaymentType && (showForScriptChannel || showForNonScriptChannel);
  const isGretaBookingNewUi = appSettings?.isGretaBookingNewUi;

  // Recap panel derived values
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const secondPageBackgroundColor =
    AppSettings && (AppSettings as any)["secondPageBackgroundColor"];

  const defaultCurrency = AppSettings?.defaultCurrency || "€";
  const vehiclePrice = VehicleDetails?.paymentDetails?.price || 0;
  // Use extrasSelected (set on mount) to preserve original insurance/extras
  // even after PaymentTypesDetails overwrites paymentDetails.extrasPrice with 0
  const insurancePrice =
    extrasSelected?.selectedInsurance?.price ||
    VehicleDetails?.paymentDetails?.selectedInsurance?.price ||
    0;
  const extrasPrice =
    extrasSelected?.extrasPrice ||
    VehicleDetails?.paymentDetails?.extrasPrice ||
    0;

  const onlyExtrasPrice = extrasPrice - insurancePrice;
  const recapTotalPrice = vehiclePrice + extrasPrice;

  const popupVehiclePrice = vehiclePrice;
  return (
    <>
      <section
        className="flex flex-col "
        style={
          isSmallScreen
            ? {
                width: "99%",
                overflow: isGretaBookingNewUi ? "visible" : "hidden",
              }
            : {
                width: "100%",
                overflow: isGretaBookingNewUi ? "visible" : "hidden",
              }
        }
      >
        <AlertMessage
          openModal={openModal}
          requestOnClose={onRequestClose}
          modalMessage={modalMessage}
        />
        {isGretaBookingNewUi && (
          <GretaHeader
            title={reviewBookingText}
            totalPrice={
              typePayment === "payLater" &&
              VehicleDetails?.vehicleDetails?.Vehicle?.payLaterSurcharge
                ? popupVehiclePrice +
                  extrasPrice +
                  ((popupVehiclePrice + extrasPrice) *
                    VehicleDetails.vehicleDetails.Vehicle.payLaterSurcharge) /
                    100
                : localSelectedPrice > 0
                ? localSelectedPrice
                : recapTotalPrice
            }
            currency={defaultCurrency}
            onBack={onBack || (() => navigateTo(-1 as any))}
            onPriceDetailClick={() => setShowPriceDetail(true)}
            translate={translate}
            priceDetailsText={priceDetailsText}
            showContinueButton={false}
            formId="payment-form"
            isSaving={isSaving}
            continueButtonStyle={{
              background: AppSettings?.continueButtonPrimaryColor
                ? AppSettings?.continueButtonPrimaryColor
                : "#f0a500",
              height: "48px",
              minWidth: "120px",
              padding: "8px 24px",
              borderRadius: `${AppSettings?.buttonBorderRadius ?? 50}px`,
            }}
          />
        )}
        <div
          className={`flex justify-center items-center ${
            isSmallScreen && !isGretaBookingNewUi ? "mt-[10%]" : ""
          }`}
        ></div>

        <div
          className={
            isGretaBookingNewUi
              ? "flex flex-col lg:flex-row grow lg:items-start mt-6 bg-[#f5f5f5] md:px-4 md:gap-4 lg:px-0 lg:gap-0"
              : "grow flex flex-col  gap-16 box-border p-6"
          }
          ref={paymentFormRef}
        >
          <form
            noValidate
            onSubmit={async (e) => {
              e.preventDefault();
              const isPaymentFormValid = await validatePaymentForm();
              if (!isPaymentFormValid) {
                return;
              }
              {
                // first check blacklist API before proceeding
                const blacklistId =
                  UserDetails?.ssnNumber || UserDetails?.vatNumber;

                if (blacklistId && restrictBlacklistCustomersFromBooking) {
                  const blacklistResponse =
                    await BookingApi.checkIfCustomerIsBlacklisted(
                      String(blacklistId)
                    );

                  if (blacklistResponse?.data?.status === "success") {
                    const message =
                      customerBlacklistMessageBody ||
                      t("Cannot continue because your profile is blacklisted.");
                    setModalMessage(message);
                    setOpenModal(true);
                    return;
                  }
                }
                setEmailError("");
                setPhoneError("");
                setInvalidError("");
                setIsSaving(true);
                setLoading(true);
                BookingApi.createBooking(
                  firstName,
                  lastName,
                  email,
                  phoneNo,
                  ReservationDetails,
                  UserDetails,
                  VehicleDetails.vehicleDetails as Vehicle,
                  VehicleDetails.paymentDetails as SelectedVehicleDetails,
                  selectedPaymentMethod,
                  companyinvoiceDetails,
                  currentLoggedInuser,
                  whetherIfGroupIsOnRequest,
                  // userType === "Company" ? "Company" : "Individual",
                  userType,
                  checked,
                  AppSettings?.payWiretransfer,
                  AppSettings?.payVpos,
                  extrasSelected?.selectedInsurance?.insuranceId,
                  extrasSelected?.addedExtraOptions,
                  extrasSelected?.extrasPrice,
                  countryList || [],
                  paymentTypeCompanyDetails,
                  hideNumberOfFieldsAtPayAtDesk,
                  enableCreditCardDeferredPayment
                ).then((e) => {
                  sessionStorage.setItem(
                    "wireTransferBookingInfo",
                    JSON.stringify(ReservationDetails)
                  );
                  if (currentPriceToPay != null) {
                    sessionStorage.setItem(
                      "currentPriceToPay",
                      String(currentPriceToPay)
                    );
                  }
                  if (typeof e !== "string" && e.data?.data?.id) {
                    let bookingDbId = e.data.data.id;
                    bookingDbId = bookingDbId.split(" ").slice(0, 2).join("");
                    sessionStorage.setItem("wireTransferDbId", bookingDbId);
                  }
                  const customer = e.data?.data?.Customer;
                  const reservationBookingDetails: PaymentBody = {
                    GivenName: customer?.GivenName || "",
                    Name: customer?.Name || "",
                    Surname: customer?.Surname || "",
                    addressNumber: customer?.addressNumber || "",
                    phNum1: customer?.phNum1 || "",
                    zip: customer?.zip || "",
                    street: customer?.street || "",
                    num: customer?.num || "",
                    email: customer?.email || "",
                    city: customer?.city || "",
                    state: customer?.state || "",
                  };
                  if (e.toString() === "invalid.customer.ssn") {
                    setIsSaving(false);
                    setLoading(false);
                    const message = invalidTaxCodeBody || t("Invalid Tax Code");
                    setModalMessage(message);
                    // setModalMessage("Invalid Tax Code");
                    setOpenModal(true);
                  } else if (e.toString() === "invalid.companyTaxCode") {
                    setIsSaving(false);
                    setLoading(false);
                    setModalMessage("Invalid Company Tax Code");
                    setOpenModal(true);
                  } else if (e.toString() === "invalid.company.vat") {
                    setIsSaving(false);
                    setLoading(false);
                    setModalMessage("Invalid VAT");
                    setOpenModal(true);
                  } else {
                    if (AppSettings?.showMyRentPolicies) {
                      const policyIds = selectedPrivacyPolicy.map(
                        (selectedPolicy) => {
                          const selectedPolicyIds: number[] = [];
                          let foundPolicy: number | undefined;
                          if (Array.isArray(selectedPolicy)) {
                            for (const p1 of selectedPolicy) {
                              let policyFound = false;
                              for (const p2 of allPrivacyPolicy) {
                                const foundPolicy = p2.find((policy) => {
                                  const policyData = p1.startsWith("*")
                                    ? p1.substring(1)
                                    : p1;
                                  return (
                                    policyData ===
                                    (i18n.language == "it"
                                      ? policy.privacyPolicyLocalLang
                                      : policy.privacyPolicyEn)
                                  );
                                });
                                if (foundPolicy) {
                                  selectedPolicyIds.push(foundPolicy.id);
                                  policyFound = true;
                                  break;
                                }
                              }
                              if (!policyFound) {
                                selectedPolicyIds.push(-1);
                              }
                            }
                          }
                          return selectedPolicyIds;
                        }
                      );
                      BookingApi.savePrivacyPolicy(
                        e?.data?.data?.dbId,
                        policyIds.flat()
                      ); // Flatten nested arrays before saving for single array
                    }

                    setReservationId(e?.data.data?.dbId);
                    setIsSaving(false);
                    setLoading(false);
                    if (e.data.data == undefined) {
                      novehicleModal(e.data.message);
                    } else {
                      switch (selectedPaymentMethod.toLowerCase()) {
                        case "paypal": {
                          if (!isEnableNewPayPalConfiguration) {
                            payPalFormRef?.current?.submit();
                          } else {
                            if (
                              AppSettings?.onrequestPayAmount &&
                              VehicleDetails.vehicleDetails?.Status.toLowerCase() ==
                                "onrequest"
                            ) {
                              BookingApi.getPaymentLink(
                                e.data.data.dbId,
                                0.01,
                                "paypal",
                                reservationBookingDetails
                              ).then((e) => {
                                if (e.paymentUrl && e.status != "failed") {
                                  window.open(e.paymentUrl, "_self");
                                  window.scrollTo(0, 0);
                                  scrollToTop();
                                } else {
                                  navigateTo(
                                    "/MovementRenewal/UrlNotDonePayPal"
                                  );
                                }
                              });
                            } else {
                              BookingApi.getPaymentLink(
                                e.data.data.dbId,
                                currentPriceToPay || 0,
                                "paypal",
                                reservationBookingDetails
                              ).then((e) => {
                                if (e.paymentUrl && e.status != "failed") {
                                  window.scrollTo(0, 0);
                                  scrollToTop();
                                  window.open(e.paymentUrl, "_self");
                                } else {
                                  navigateTo(
                                    "/MovementRenewal/UrlNotDonePayPal"
                                  );
                                }
                              });
                            }
                          }
                          break;
                        }
                        case "nexi": {
                          const handleNexiPayment = (link: string) => {
                            window.scrollTo(0, 0);
                            scrollToTop();
                            window.open(link, "_self");
                            window.scrollTo(0, 0);
                            scrollToTop();
                          };

                          const processNexiResponse = (e: {
                            bookingPaymentLink?: string;
                            generateLink?: string;
                          }) => {
                            console.log(
                              e.bookingPaymentLink,
                              "e.bookingPaymentLink"
                            );
                            console.log(e.generateLink, "e.generateLink");
                            const paymentLink =
                              e.bookingPaymentLink || e.generateLink;
                            if (paymentLink) {
                              handleNexiPayment(paymentLink);
                            }
                          };

                          if (
                            (AppSettings?.onrequestPayAmount &&
                              VehicleDetails.vehicleDetails?.Status.toLowerCase() ===
                                "onrequest") ||
                            (AppSettings?.enablePayLaterPreAuth &&
                              typePayment === "payLater")
                          ) {
                            BookingApi.getPaymentLink(
                              e.data.data.dbId,
                              0.01,
                              "nexi",
                              reservationBookingDetails,
                              "D"
                            ).then(processNexiResponse);
                          } else {
                            BookingApi.getPaymentLink(
                              e.data.data.dbId,
                              currentPriceToPay || 0,
                              "nexi",
                              reservationBookingDetails,
                              "C"
                            ).then(processNexiResponse);
                          }
                          break;
                        }
                        case "datatrans": {
                          const isDatatransDepositFlow =
                            (AppSettings?.onrequestPayAmount &&
                              VehicleDetails.vehicleDetails?.Status.toLowerCase() ===
                                "onrequest") ||
                            (AppSettings?.enablePayLaterPreAuth &&
                              typePayment === "payLater");

                          BookingApi.initDatatransPayment(
                            String(e.data.data.dbId),
                            (isDatatransDepositFlow
                              ? 0.5
                              : currentPriceToPay || 0
                            ).toString(),
                            AppSettings?.defaultCurrency || "EUR",
                            isDatatransDepositFlow ? "D" : "C"
                          )
                            .then((res) => {
                              if (res?.paymentUrl) {
                                window.scrollTo(0, 0);
                                scrollToTop();
                                window.open(res.paymentUrl, "_self");
                              } else {
                                navigateTo(
                                  "/MovementRenewal/UrlNotDoneDatatrans"
                                );
                              }
                            })
                            .catch(() => {
                              navigateTo(
                                "/MovementRenewal/UrlNotDoneDatatrans"
                              );
                            });
                          break;
                        }
                        case "scalapay": {
                          if (
                            AppSettings?.onrequestPayAmount &&
                            VehicleDetails.vehicleDetails?.Status.toLowerCase() ==
                              "onrequest"
                          ) {
                            BookingApi.getPaymentLink(
                              e.data.data.dbId,
                              0.01,
                              "scalapay",
                              reservationBookingDetails
                            ).then((e) => {
                              if (e.paymentUrl && e.status != "failed") {
                                window.scrollTo(0, 0);
                                scrollToTop();
                                (window.top || window).location.href =
                                  e.paymentUrl;
                              } else {
                                navigateTo(
                                  "/MovementRenewal/UrlNotDoneScalapay"
                                );
                              }
                            });
                          } else {
                            BookingApi.getPaymentLink(
                              e.data.data.dbId,
                              currentPriceToPay || 0,
                              "scalapay",
                              reservationBookingDetails
                            ).then((e) => {
                              if (e.paymentUrl && e.status != "failed") {
                                window.scrollTo(0, 0);
                                scrollToTop();
                                (window.top || window).location.href =
                                  e.paymentUrl;
                              } else {
                                navigateTo(
                                  "/MovementRenewal/UrlNotDoneScalapay"
                                );
                              }
                            });
                          }
                          break;
                        }
                        // case "stripe": {
                        //   // Save booking data for the confirmation page
                        //   const bookingData = e.data?.data || e.data;
                        //   const rawDbId = (bookingData?.id || "")
                        //     .split(" ")
                        //     .slice(0, 2)
                        //     .join("");
                        //   const stripeConfirmData = {
                        //     dbId: rawDbId,
                        //     vehicleName:
                        //       bookingData?.Vehicle?.VehMakeModel?.Name || "",
                        //     vehicleCategory: bookingData?.Vehicle?.Code || "",
                        //     returnDateTime: bookingData?.ReturnDateTime || "",
                        //   };
                        //   sessionStorage.setItem(
                        //     "stripeBookingConfirmData",
                        //     JSON.stringify(stripeConfirmData)
                        //   );

                        //   const reservationDbId = bookingData?.dbId;

                        //   // Deposit flow: on-request vehicles or pay-later pre-auth
                        //   // charge €0.50 now; full amount charged after confirmation
                        //   const isDepositFlow =
                        //     (AppSettings?.onrequestPayAmount &&
                        //       VehicleDetails.vehicleDetails?.Status.toLowerCase() ===
                        //         "onrequest") ||
                        //     (AppSettings?.enablePayLaterPreAuth &&
                        //       typePayment === "payLater");

                        //   const stripeAmount = isDepositFlow
                        //     ? 0.5
                        //     : currentPriceToPay || 0;

                        //   console.log(
                        //     "[Stripe] isDepositFlow:",
                        //     isDepositFlow,
                        //     "amount:",
                        //     stripeAmount
                        //   );

                        //   setStripeChargeOrDep(isDepositFlow ? "D" : "C");
                        //   setStripeDisplayAmount(stripeAmount);
                        //   BookingApi.fetchStripePaymentDetailsAndConfig(
                        //     isDepositFlow ? "D" : "C",
                        //     stripeAmount.toString(),
                        //     String(reservationDbId)
                        //   )
                        //     .then((stripeData) => {
                        //       console.log(
                        //         "[Stripe] PaymentIntent data:",
                        //         stripeData
                        //       );
                        //       // const clientSecret =
                        //       //   stripeData?.client_secret ||
                        //       //   stripeData?.clientSecret;
                        //       const paymentIntent = stripeData?.paymentIntent; // whole object
                        //       const clientSecret = paymentIntent?.client_secret;
                        //       setStripeClientSecret(clientSecret);
                        //       setStripeReservationDbId(reservationDbId);
                        //       setStripePublishableKey(
                        //         stripeData?.publishableKey
                        //       );
                        //       setStripePriceId(stripeData?.priceId || "");
                        //       setIsSaving(false);
                        //       setLoading(false);
                        //       setStripeEmbeddedOpen(true);
                        //     })
                        //     .catch(() => {
                        //       setIsSaving(false);
                        //       setLoading(false);
                        //     });
                        //   break;
                        // }
                        case "stripe": {
                          // Deposit flow: on-request vehicles or pay-later pre-auth
                          // Charge €0.50 now; full amount charged after confirmation
                          const isDepositFlow =
                            (AppSettings?.onrequestPayAmount &&
                              VehicleDetails.vehicleDetails?.Status.toLowerCase() ===
                                "onrequest") ||
                            (AppSettings?.enablePayLaterPreAuth &&
                              typePayment === "payLater");

                          if (AppSettings?.stripePaymentWithoutLink) {
                            // ─────────────────────────────────────────────────────────────
                            // Embedded Stripe Flow
                            // ─────────────────────────────────────────────────────────────
                            const bookingData = e.data?.data || e.data;

                            const rawDbId = (bookingData?.id || "")
                              .split(" ")
                              .slice(0, 2)
                              .join("");

                            sessionStorage.setItem(
                              "stripeBookingConfirmData",
                              JSON.stringify({
                                dbId: rawDbId,
                                vehicleName:
                                  bookingData?.Vehicle?.VehMakeModel?.Name ||
                                  "",
                                vehicleCategory:
                                  bookingData?.Vehicle?.Code || "",
                                returnDateTime:
                                  bookingData?.ReturnDateTime || "",
                              })
                            );

                            const reservationDbId = bookingData?.dbId;

                            const stripeAmount = isDepositFlow
                              ? 0.5
                              : currentPriceToPay || 0;

                            setStripeChargeOrDep(isDepositFlow ? "D" : "C");
                            setStripeDisplayAmount(stripeAmount);

                            BookingApi.fetchStripePaymentDetailsAndConfig(
                              isDepositFlow ? "D" : "C",
                              stripeAmount.toString(),
                              String(reservationDbId)
                            )
                              .then((stripeData) => {
                                const paymentIntent = stripeData?.paymentIntent;
                                const clientSecret =
                                  paymentIntent?.client_secret;

                                setStripeClientSecret(clientSecret);
                                setStripeReservationDbId(reservationDbId);
                                setStripePublishableKey(
                                  stripeData?.publishableKey
                                );
                                setStripePriceId(stripeData?.priceId || "");

                                setIsSaving(false);
                                setLoading(false);
                                setStripeEmbeddedOpen(true);
                              })
                              .catch(() => {
                                setIsSaving(false);
                                setLoading(false);
                              });
                          } else {
                            // ─────────────────────────────────────────────────────────────
                            // Old Redirect-Based Stripe Flow
                            // ─────────────────────────────────────────────────────────────
                            BookingApi.getPaymentLink(
                              e.data.data.dbId,
                              isDepositFlow ? 0.5 : currentPriceToPay || 0,
                              "Stripe",
                              reservationBookingDetails,
                              isDepositFlow ? "D" : "C"
                            ).then((e) => {
                              if (e.paymentUrl) {
                                const paymentData = {
                                  ...e,
                                  paymentMode: "Stripe",
                                };

                                if (paymentData.paymentUrl && window.top) {
                                  window.top.location.href =
                                    paymentData.paymentUrl;
                                } else {
                                  window.open(paymentData.paymentUrl, "top");
                                }
                              }
                            });
                          }

                          break;
                        }
                        case "wiretransfer": {
                          let dbId = e.data.data?.id;
                          dbId = dbId.split(" ").slice(0, 2).join("");
                          const ResId = e.data.data?.dbId;
                          BookingApi.sendEmailForWireTransfer(
                            e.data.data?.dbId,
                            whetherIfGroupIsOnRequest,
                            i18n.language,
                            id || ""
                          );
                          navigateTo(
                            `/booking/confirmed?dbId=${dbId}&ResId=${ResId}&vehicleName=${e.data.data.Vehicle.VehMakeModel.Name}&vehicleCategory=${e.data.data.Vehicle.Code}&DropOffUpDateTime=${e.data.data.ReturnDateTime}&importo=${currentPriceToPay}`
                          );

                          break;
                        }
                        default: {
                          BookingApi.getPaymentLink(
                            e.data.data.dbId,
                            currentPriceToPay || 0,
                            "nexi"
                          ).then((e) => {
                            if (e.generateLink) {
                              window.scrollTo(0, 0);
                              scrollToTop();
                              window.open(e.generateLink, "_self");
                              window.scrollTo(0, 0);
                              scrollToTop();
                            }
                          });
                          return;
                        }
                      }
                    }
                  }
                });
              }
            }}
            className={
              isGretaBookingNewUi
                ? "flex flex-col gap-4 box-border px-4 py-2 bg-[#f5f5f5] w-full lg:w-[70%] md:order-last lg:order-none"
                : "grow flex flex-col gap-16 box-border p-4 bg-gray-100"
            }
          >
            {/* Freeze overlay — covers all form fields (zIndex 1001 > AppDatePicker
              wrapper's 1000) when Stripe is active. Stripe section sits at 1002. */}
            {(stripeEmbeddedOpen || stripePaymentSuccess) && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  zIndex: 1001,
                  backgroundColor: "rgba(243,244,246,0.72)",
                  backdropFilter: "blur(1px)",
                  cursor: "not-allowed",
                  pointerEvents: "all",
                }}
              />
            )}
            {AppSettings?.showOldPaymentForm ? (
              AppSettings?.showCompanyDetailsPriorPersonal ? (
                <>
                  <CompanyDetails
                    checked={checked}
                    handleChange={handleChange}
                    userType={userType}
                    handleUserType={handleUserType}
                    setCompanyinvoiceDetails={setCompanyinvoiceDetails}
                    companyinvoiceDetails={companyinvoiceDetails}
                  />
                  <PersonalDetails
                    reservationSourcePayNow={reservationSourcePayNow}
                    reservationSourcePayLater={reservationSourcePayLater}
                    extrasSelected={extrasSelected}
                    updateVehiclePrice={updateVehiclePrice}
                    updateVehiclePriceLater={updateVehiclePriceLater}
                    updateSelectedPrice={updateSelectedPrice}
                  />
                </>
              ) : (
                <>
                  <PersonalDetails
                    reservationSourcePayNow={reservationSourcePayNow}
                    reservationSourcePayLater={reservationSourcePayLater}
                    extrasSelected={extrasSelected}
                    updateVehiclePrice={updateVehiclePrice}
                    updateSelectedPrice={updateSelectedPrice}
                    updateVehiclePriceLater={updateVehiclePriceLater}
                  />
                  <CompanyDetails
                    checked={checked}
                    handleChange={handleChange}
                    userType={userType}
                    handleUserType={handleUserType}
                    setCompanyinvoiceDetails={setCompanyinvoiceDetails}
                    companyinvoiceDetails={companyinvoiceDetails}
                  />
                </>
              )
            ) : (
              <>
                <NewPersonalDetails
                  reservationSourcePayNow={reservationSourcePayNow}
                  reservationSourcePayLater={reservationSourcePayLater}
                  extrasSelected={extrasSelected}
                  updateVehiclePrice={updateVehiclePrice}
                  updateSelectedPrice={updateSelectedPrice}
                  updateUserPrimaryDetails={updateUserPrimaryDetails}
                  firstName={firstName}
                  lastName={lastName}
                  email={email}
                  phoneNo={phoneNo}
                  emailError={emailError}
                  emailRef={emailRef}
                  phoneRef={phoneRef}
                  phoneError={phoneError}
                  personalDetailsErrorText={personalDetailsErrorText}
                  setPersonalDetailsErrorText={setPersonalDetailsErrorText}
                  onPaymentTypeChange={onPaymentTypeChange}
                  checkPaymentType={setTypePayment}
                  updateVehiclePriceLater={updateVehiclePriceLater}
                  readOnlyName={
                    userId != null &&
                    userId !== "null" &&
                    userId !== "" &&
                    customerDetails?.customerType === "INDIVIDUAL"
                  }
                />
                {/*<NewCompanyDetails*/}
                {/*  isAirport={isAirport}*/}
                {/*  userType={userType}*/}
                {/*  handleUserType={handleUserType}*/}
                {/*  setCompanyinvoiceDetails={setCompanyinvoiceDetails}*/}
                {/*  companyinvoiceDetails={companyinvoiceDetails}*/}
                {/*  phoneRef={phoneRef}*/}
                {/*  phoneError={phoneError}*/}
                {/*  dateError={dateError}*/}
                {/*/>*/}
                {hideNumberOfFieldsAtPayAtDesk === false &&
                  (paymentType === "payNow" || paymentType === "payLater") && (
                    <NewCompanyDetails
                      isAirport={isAirport}
                      userType={userType}
                      handleUserType={handleUserType}
                      setCompanyinvoiceDetails={setCompanyinvoiceDetails}
                      companyinvoiceDetails={companyinvoiceDetails}
                      phoneRef={phoneRef}
                      phoneError={phoneError}
                      dateError={dateError}
                      hideNumberOfFieldsAtPayAtDesk={
                        hideNumberOfFieldsAtPayAtDesk
                      }
                      paymentType={paymentTypeCompanyDetails}
                      setHandleBillingHeight={setHandleBillingHeight}
                      reservationSourcePayNow={reservationSourcePayNow}
                      reservationSourcePayLater={reservationSourcePayLater}
                      scriptChannel={scriptChannel}
                      privateValidateRef={privateValidateRef}
                      companyValidateRef={companyValidateRef}
                      customerDetails={customerDetails}
                    />
                  )}

                {hideNumberOfFieldsAtPayAtDesk === true &&
                  (paymentType === "payNow" || paymentType === "payLater") && (
                    <NewCompanyDetails
                      isAirport={isAirport}
                      userType={userType}
                      handleUserType={handleUserType}
                      setCompanyinvoiceDetails={setCompanyinvoiceDetails}
                      companyinvoiceDetails={companyinvoiceDetails}
                      phoneRef={phoneRef}
                      phoneError={phoneError}
                      dateError={dateError}
                      hideNumberOfFieldsAtPayAtDesk={
                        hideNumberOfFieldsAtPayAtDesk
                      }
                      paymentType={paymentTypeCompanyDetails}
                      setHandleBillingHeight={setHandleBillingHeight}
                      reservationSourcePayNow={reservationSourcePayNow}
                      reservationSourcePayLater={reservationSourcePayLater}
                      scriptChannel={scriptChannel}
                      privateValidateRef={privateValidateRef}
                      companyValidateRef={companyValidateRef}
                      customerDetails={customerDetails}
                    />
                  )}
              </>
            )}
            <div ref={termsRef}>
              <TermsAndConditions
                updateSelectedPrivacyPolicy={updateSelectedPrivacyPolicy}
                selectedPrivacyPolicy={selectedPrivacyPolicy}
                allPrivacyPolicy={allPrivacyPolicy}
                requiredPolicy={requiredPolicy}
                onTermsAcceptedChange={(accepted: boolean) => {
                  setTermsAccepted(accepted);
                  if (accepted) setTermsError("");
                }}
                termsError={termsError}
              />
            </div>
            {((currentLoggedInuser &&
              AppSettings?.reservedAreaShowOnlyOnePayment) ||
              isHidePayCounterRadio) &&
            AppSettings?.showConfirmButtonAtMiddle ? (
              <div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <p className="text-red-500">{invalidError}</p>
                  <AppButton
                    loading={isSaving}
                    type="submit"
                    color="primary"
                    className="h-12 w-44 flex justify-center rounded-sm"
                    style={{
                      borderRadius: `${AppSettings?.buttonBorderRadius || 0}px`,
                    }}
                  >
                    <span className="flex text-center w-full h-full mt-3 justify-center">
                      {t("Confirm")}
                    </span>
                  </AppButton>
                </div>
              </div>
            ) : (
              <footer
                className={`flex flex-row flex-wrap box-border p-4 md:p-5 lg:p-8 ${
                  isGretaBookingNewUi ? "" : "bg-white"
                }`}
                style={
                  isGretaBookingNewUi
                    ? {
                        position: "relative",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }
                    : undefined
                }
              >
                <div className="flex flex-col grow">
                  {!isReservedAreaUser && !isHidePayCounterRadio ? (
                    <>
                      <AppRadioButton
                        required={true}
                        color={"primary"}
                        disableLabelFocusColor
                        label={<span>{t("Mode of Payment")}</span>}
                        value={selectedPaymentMethod}
                        options={(isSmallScreen || isTabletScreen
                          ? Object.keys(allNewPaymentMethods).reverse()
                          : Object.keys(allNewPaymentMethods)
                        )
                          .map((key) => {
                            switch (key.toUpperCase()) {
                              case "WIRETRANSFER":
                                return {
                                  label: t("Pay at desk"),
                                  value: "WIRETRANSFER",
                                };
                              case "PAYPAL":
                                return {
                                  label: paypalBody ? paypalBody : t("PayPal"),
                                  value: "PAYPAL",
                                };
                              case "NEXI":
                                return {
                                  label: nexiBody ? nexiBody : t("Credit card"),
                                  value: "NEXI",
                                };
                              case "DATATRANS":
                                return {
                                  label: datatransBody
                                    ? datatransBody
                                    : t("Pay with DataTrans"),
                                  value: "DATATRANS",
                                };
                              case "STRIPE":
                                return {
                                  label: stripeBody ? stripeBody : t("Stripe"),
                                  value: "STRIPE",
                                };
                              case "SCALAPAY":
                                return {
                                  label: (
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <span>
                                        {scalapayBody
                                          ? scalapayBody
                                          : t("Pay with Scalapay")}
                                      </span>
                                      <img
                                        src="/images/Scalapay_Logo_Primary_Black.png"
                                        alt="Scalapay"
                                        style={{
                                          height: "60px",
                                          width: "100px",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </span>
                                  ),
                                  value: "SCALAPAY",
                                };
                              default:
                                return {
                                  label: "",
                                  value: "",
                                };
                            }
                          })
                          .flat()
                          .filter((option) => option !== null)}
                        onChange={(e) => {
                          setSelectedPaymentMethod(e);
                        }}
                      />
                      {shouldShowScalapayWidget && (
                        <div style={{ paddingTop: "5px" }}>
                          <hr style={{ border: ".3px solid #ccc" }} />
                          <div
                            style={{
                              paddingTop: "4px",
                              fontSize: "12px",
                              color: "#000",
                            }}
                          >
                            <scalapay-widget
                              locale={localeScalapay}
                              channel="travel"
                              type="checkout"
                              amount={currentPriceToPay.toFixed(2)}
                              merchant-token={scalapayMerchantToken}
                              {...(scalapayEnvVal !== ""
                                ? { environment: scalapayEnvVal }
                                : {})}
                            />
                          </div>
                        </div>
                      )}

                      {/* ── Stripe section — sits above the freeze overlay ──── */}
                      <div
                        ref={stripeFormRef}
                        style={{
                          position: "relative",
                          zIndex:
                            stripeEmbeddedOpen || stripePaymentSuccess
                              ? 1002
                              : "auto",
                          maxWidth: isSmallScreen ? "100%" : "520px",
                          width: "100%",
                          margin: "16px auto 0",
                        }}
                      >
                        {stripeEmbeddedOpen && stripeClientSecret && (
                          <StripeEmbeddedPayment
                            clientSecret={stripeClientSecret}
                            reservationDbId={stripeReservationDbId}
                            currentPriceToPay={stripeDisplayAmount}
                            totalAmount={currentPriceToPay || 0}
                            onClose={() => {
                              setStripeEmbeddedOpen(false);
                              setIsSaving(false);
                              setLoading(false);
                            }}
                            onSuccess={() => {
                              const confirmData = JSON.parse(
                                sessionStorage.getItem(
                                  "stripeBookingConfirmData"
                                ) || "{}"
                              );

                              stripeConfirmUrlRef.current = `/booking/confirmed?dbId=${encodeURIComponent(
                                confirmData.dbId || ""
                              )}&ResId=${stripeReservationDbId}&vehicleName=${encodeURIComponent(
                                confirmData.vehicleName || ""
                              )}&vehicleCategory=${encodeURIComponent(
                                confirmData.vehicleCategory || ""
                              )}&DropOffUpDateTime=${encodeURIComponent(
                                confirmData.returnDateTime || ""
                              )}&importo=${currentPriceToPay}`;

                              setStripeEmbeddedOpen(false);
                              setIsSaving(false);
                              setLoading(false);
                              setStripePaymentSuccess(true);
                            }}
                            publishableKey={stripePublishableKey}
                            isChargeOrDep={stripeChargeOrDep}
                            priceId={stripePriceId}
                          />
                        )}

                        {stripePaymentSuccess && (
                          <div className="w-full mt-4 rounded-xl bg-white p-8 text-center shadow-lg border border-gray-100">
                            <div className="flex justify-center mb-4">
                              <div className="rounded-full bg-green-100 p-4">
                                <svg
                                  className="w-10 h-10 text-green-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  strokeWidth={2.5}
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M5 13l4 4L19 7"
                                  />
                                </svg>
                              </div>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-1">
                              {t("Payment Successful!")}
                            </h3>
                            <p className="text-sm text-gray-500 mb-5">
                              {t(
                                "Redirecting you to your booking confirmation..."
                              )}
                            </p>
                            <div className="flex justify-center items-center gap-2 mb-6 text-sm text-gray-400">
                              <svg
                                className="animate-spin h-4 w-4 text-gray-400"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                />
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v8z"
                                />
                              </svg>
                              <span>{t("Please wait...")}</span>
                            </div>
                            <button
                              type="button"
                              onClick={() =>
                                navigateTo(stripeConfirmUrlRef.current)
                              }
                              className="w-full h-11 rounded text-white text-sm font-semibold"
                              style={{
                                borderRadius: `${
                                  AppSettings?.buttonBorderRadius || 0
                                }px`,
                                backgroundColor:
                                  "var(--primary-color, #1976d2)",
                              }}
                            >
                              {t("Go to Confirmation")} →
                            </button>
                          </div>
                        )}
                      </div>
                      {/* ── end Stripe section ─────────────────────────────── */}
                    </>
                  ) : null}
                </div>

                {/* Hide the standard Confirm button while Stripe element is active */}
                {!stripeEmbeddedOpen && !stripePaymentSuccess && (
                  <div className="flex flex-row gap-6 items-center">
                    <p className="text-red-500">{invalidError}</p>
                    <AppButton
                      loading={isSaving}
                      type="submit"
                      color="primary"
                      className="h-12 w-44 flex justify-center rounded-sm"
                      style={{
                        borderRadius: `${
                          AppSettings?.buttonBorderRadius || 0
                        }px`,
                      }}
                    >
                      <span className="flex text-center w-full h-full mt-3 justify-center">
                        {t("Confirm")}
                      </span>
                    </AppButton>
                  </div>
                )}
                {/* Cancellation policy message — always visible regardless of
                  payNow / payLater or selected payment method (CMS-driven,
                  language follows textResource) */}
                {cancellationPolicyMsg && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: cancellationPolicyMsg,
                    }}
                    className={"text-black w-full mt-2"}
                  />
                )}
                <span
                  dangerouslySetInnerHTML={{
                    __html: bookingPaymentSubDescData || "",
                  }}
                  className={"text-black w-full mt-2"}
                />
                <div className="flex flex-row text-[#707070] mt-4 mb-2">
                  {AppSettings?.onrequestPayAmount &&
                  VehicleDetails.vehicleDetails?.Status.toLowerCase() ==
                    "onrequest"
                    ? t(
                        "The reservation will be subjected to confirmation – during the payment process, you will be asked to pay €0.01 and, once the reservation is confirmed, you will be charged the total amount of the rental on the registered credit card."
                      )
                    : ""}
                </div>
              </footer>
            )}
          </form>
          {isGretaBookingNewUi && (
            <div
              className="w-full lg:w-[30%] lg:sticky lg:top-[80px] lg:self-start lg:max-h-[calc(100vh-80px)] lg:overflow-y-auto p-8 md:order-first lg:order-last"
              style={{ background: secondPageBackgroundColor || "#f3f4f6" }}
            >
              <div className="bg-[#e8e8e8] rounded-2xl overflow-hidden">
                {/* Vehicle header */}
                <div className="flex items-center gap-3 p-4 border-b border-gray-100">
                  {(VehicleDetails.vehicleDetails?.Vehicle?.vehicleGroupPic ||
                    (
                      VehicleDetails.vehicleDetails?.Vehicle
                        ?.vehicelExtraImage as any
                    )?.[0]) && (
                    <img
                      src={
                        VehicleDetails.vehicleDetails?.Vehicle
                          ?.vehicleGroupPic ||
                        ((
                          VehicleDetails.vehicleDetails?.Vehicle
                            ?.vehicelExtraImage as any
                        )?.[0] as string)
                      }
                      alt=""
                      className="h-14 w-20 object-contain flex-shrink-0"
                    />
                  )}
                  <div className="flex-1">
                    <p className="font-bold text-sm md:text-xs lg:text-base text-black leading-tight">
                      {
                        VehicleDetails.vehicleDetails?.Vehicle?.VehMakeModel
                          ?.Name
                      }
                    </p>
                    <p className="text-xs text-gray-400 mt-0.5">
                      {t("o Similare")}
                    </p>
                  </div>
                  {/* Expand/collapse arrow — mobile only */}
                  <button
                    type="button"
                    onClick={() => setRecapExpanded((prev) => !prev)}
                    className="lg:hidden flex items-center justify-center w-8 h-8 flex-shrink-0"
                    aria-label="toggle details"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-4 h-4 text-gray-600"
                      style={{
                        transform: recapExpanded
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        transition: "transform 0.2s ease",
                      }}
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </button>
                </div>

                {/* Collapsible details — hidden on mobile until arrow is clicked */}
                <div
                  className={`${recapExpanded ? "block" : "hidden"} lg:block`}
                >
                  {/* Ritiro e restituzione */}
                  <div className="p-4 border-b border-gray-100">
                    <p className="font-bold text-base text-black mb-3">
                      {t("Pickup and return")}
                    </p>
                    <div className="flex flex-col">
                      {/* Pickup row */}
                      <div className="flex gap-3">
                        <div className="flex flex-col items-center flex-shrink-0">
                          <OtherHousesIcon
                            style={{ fontSize: 18, color: "black" }}
                          />
                          <div
                            className="bg-black"
                            style={{ width: 1, minHeight: 80, margin: "3px 0" }}
                          />
                        </div>
                        <div className="pb-4 flex-1">
                          <p className="text-xs text-gray-400 mb-0.5">
                            {t("Pick-up")}
                          </p>
                          <p className="font-bold text-sm text-black">
                            {AppSettings?.showLocationNameInSummary
                              ? ReservationDetails?.pickUpLocationName
                              : ReservationDetails?.pickUpLocationDetails
                                  ?.name ||
                                ReservationDetails?.pickUpLocationDetails?.code}
                          </p>
                          <p className="text-xs text-gray-500">
                            {ReservationDetails?.pickUpDateAndTime
                              ? `${new Date(
                                  ReservationDetails.pickUpDateAndTime
                                ).toLocaleDateString(
                                  lang === "it" ? "it-IT" : "en-US",
                                  {
                                    weekday: "short",
                                    day: "numeric",
                                    month: "short",
                                    year: "numeric",
                                  }
                                )} | ${new Date(
                                  ReservationDetails.pickUpDateAndTime
                                )
                                  .getHours()
                                  .toString()
                                  .padStart(2, "0")}:${new Date(
                                  ReservationDetails.pickUpDateAndTime
                                )
                                  .getMinutes()
                                  .toString()
                                  .padStart(2, "0")}`
                              : ""}
                          </p>
                        </div>
                      </div>
                      {/* Dropoff row */}
                      <div className="flex gap-3">
                        <div className="flex-shrink-0">
                          <OtherHousesIcon
                            style={{ fontSize: 18, color: "black" }}
                          />
                        </div>
                        <div className="flex-1">
                          <p className="text-xs text-gray-400 mb-0.5">
                            {t("Return")}
                          </p>
                          <p className="font-bold text-sm text-black">
                            {AppSettings?.showLocationNameInSummary
                              ? ReservationDetails?.dropOffLocationName
                              : ReservationDetails?.dropOffLocationDetails
                                  ?.name ||
                                ReservationDetails?.dropOffLocationDetails
                                  ?.code}
                          </p>
                          <p className="text-xs text-gray-500">
                            {ReservationDetails?.dropOffDateAndTime
                              ? `${new Date(
                                  ReservationDetails.dropOffDateAndTime
                                ).toLocaleDateString(
                                  lang === "it" ? "it-IT" : "en-US",
                                  {
                                    weekday: "short",
                                    day: "numeric",
                                    month: "short",
                                    year: "numeric",
                                  }
                                )} | ${new Date(
                                  ReservationDetails.dropOffDateAndTime
                                )
                                  .getHours()
                                  .toString()
                                  .padStart(2, "0")}:${new Date(
                                  ReservationDetails.dropOffDateAndTime
                                )
                                  .getMinutes()
                                  .toString()
                                  .padStart(2, "0")}`
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Cosa è incluso */}
                  <div className="p-4 border-b border-gray-100">
                    <p className="font-bold text-base text-black mb-3">
                      {t("Cosa è incluso")}
                    </p>
                    {/* Vehicle Details */}
                    {VehicleDetails.vehicleDetails.Vehicle?.vehicleParameter?.map(
                      (item, i) => (
                        <div key={i} className="flex items-center gap-2 mb-2">
                          <span className="text-sm text-gray-600 font-bold">
                            ✓
                          </span>
                          <span className="text-sm text-gray-700">
                            {item.name || item["name :"]}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                  {(extrasSelected?.selectedInsurance?.details ||
                    Object.keys(extrasSelected?.addedExtraOptions || {})
                      .length > 0) && (
                    <div className="p-4 border-b border-gray-100">
                      {/* Insurance name */}
                      {extrasSelected?.selectedInsurance?.details && (
                        <div className="flex items-center gap-2 mb-2">
                          <span className="text-sm text-gray-600 font-bold">
                            ✓
                          </span>
                          <span className="text-sm text-gray-700">
                            {extrasSelected.selectedInsurance.details}
                          </span>
                        </div>
                      )}
                      {/* Extras names */}
                      {Object.values(
                        ((extrasSelected?.addedExtraOptions ||
                          VehicleDetails.paymentDetails
                            ?.addedExtraOptions) as Record<
                          string,
                          { name: string }
                        >) || {}
                      ).map((extra, i) => (
                        <div key={i} className="flex items-center gap-2 mb-2">
                          <span className="text-sm text-gray-600 font-bold">
                            ✓
                          </span>
                          <span className="text-sm text-gray-700">
                            {extra.name}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {/* end collapsible details */}
              </div>
            </div>
          )}
        </div>

        {/* Dettagli del prezzo modal */}
        <Dialog
          open={showPriceDetail}
          onClose={() => setShowPriceDetail(false)}
          sx={{
            "& .MuiDialog-container": {
              alignItems: "flex-start",
              paddingTop: "100px",
            },
          }}
          PaperProps={{
            style: {
              borderRadius: 16,
              minWidth: "min(320px, 90vw)",
              maxWidth: 480,
            },
          }}
        >
          <div className="p-6 relative">
            {/* Close button */}
            <button
              onClick={() => setShowPriceDetail(false)}
              style={{
                position: "absolute",
                top: 3,
                right: 12,
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "35px",
                lineHeight: 1,
                color: "#666",
              }}
            >
              ×
            </button>
            {/* Header */}
            <div className="mb-5">
              <h2 className="font-bold text-xl uppercase tracking-wide">
                {priceDetailsText}
              </h2>
            </div>

            {/* Costi di noleggio */}
            <p className="font-bold text-sm text-black mb-2">
              {rentalCostsText}
            </p>
            <div className="flex justify-between text-sm text-gray-700 mb-1">
              <span>{translate("Totale Noleggio:")}</span>
              <span>
                {defaultCurrency}
                {popupVehiclePrice.toFixed(2)}
              </span>
            </div>

            {/* Insurance — independent of extras */}
            {!AppSettings?.donotShowInsurance && insurancePrice > 0 && (
              <div className="flex justify-between text-sm text-gray-700 mb-1">
                <span>
                  {extrasSelected?.selectedInsurance?.details ||
                    VehicleDetails.paymentDetails?.selectedInsurance?.details ||
                    translate("Assicurazione")}
                </span>
                <span>
                  {defaultCurrency}
                  {insurancePrice.toFixed(2)}
                </span>
              </div>
            )}

            {/* Extras — independent of insurance */}
            {!AppSettings?.donotShowExtras && onlyExtrasPrice > 0 && (
              <>
                <p className="font-bold text-sm text-black mt-4 mb-2">
                  {translate("Extras")}
                </p>
                {Object.values(
                  ((extrasSelected?.addedExtraOptions ||
                    VehicleDetails.paymentDetails?.addedExtraOptions) as Record<
                    string,
                    { name: string; price: number; quantity: number }
                  >) || {}
                ).map((extra, i) => (
                  <div
                    key={i}
                    className="flex justify-between text-sm text-gray-700 mb-1"
                  >
                    <span>{extra.name}</span>
                    <span>
                      {defaultCurrency}
                      {(extra.price * extra.quantity).toFixed(2)}
                    </span>
                  </div>
                ))}
              </>
            )}

            {/* Total */}
            <hr className="my-4 border-gray-200" />
            <div className="flex justify-between font-bold text-base text-black">
              <span>{translate("Total")}</span>
              <span>
                {defaultCurrency}
                {(popupVehiclePrice + extrasPrice).toFixed(2)}
              </span>
            </div>

            {/* Surcharge + Final Total — only for pay-later when surcharge exists */}
            {typePayment === "payLater" &&
              VehicleDetails?.vehicleDetails?.Vehicle?.payLaterSurcharge && (
                <>
                  <div className="flex justify-between items-start text-sm text-gray-500 mt-2 gap-4">
                    <span className="flex-1 min-w-0 break-words">
                      {payLaterLabelText}{" "}
                      {VehicleDetails.vehicleDetails.Vehicle.payLaterSurcharge}%
                    </span>
                    <span className="whitespace-nowrap flex-shrink-0">
                      {defaultCurrency}
                      {(
                        ((popupVehiclePrice + extrasPrice) *
                          VehicleDetails.vehicleDetails.Vehicle
                            .payLaterSurcharge) /
                        100
                      ).toFixed(2)}
                    </span>
                  </div>
                  <hr className="my-4 border-gray-200" />
                  <div className="flex justify-between font-bold text-base text-black">
                    <span>{translate("Totale finale")}</span>
                    <span>
                      {defaultCurrency}
                      {(
                        popupVehiclePrice +
                        extrasPrice +
                        ((popupVehiclePrice + extrasPrice) *
                          VehicleDetails.vehicleDetails.Vehicle
                            .payLaterSurcharge) /
                          100
                      ).toFixed(2)}
                    </span>
                  </div>
                </>
              )}
          </div>
        </Dialog>
        <div className={"text-black hidden"}>
          {allNewPaymentMethods?.paypal &&
            allNewPaymentMethods?.paypal?.length > 0 && (
              <PayPal
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ref={payPalFormRef}
                postUrl={
                  allNewPaymentMethods.paypal[0]?.developmentMode
                    ? allNewPaymentMethods.paypal[0]?.sandboxPaymentURL || ""
                    : allNewPaymentMethods.paypal[0]?.productionPaymentURL || ""
                }
                companyEmail={
                  allNewPaymentMethods.paypal[0]?.developmentMode
                    ? allNewPaymentMethods.paypal[0]?.sandboxEmailCompany || ""
                    : allNewPaymentMethods.paypal[0]?.productionEmailCompany ||
                      ""
                }
                amount={currentPriceToPay || 0}
                returnLink={
                  allNewPaymentMethods.paypal[0]?.developmentMode
                    ? allNewPaymentMethods.paypal[0]?.sandboxReturnURL || ""
                    : allNewPaymentMethods.paypal[0]?.productionReturnURL || ""
                }
                notify_url={
                  allNewPaymentMethods.paypal[0]?.developmentMode
                    ? allNewPaymentMethods.paypal[0]?.sandboxNotifyURL || ""
                    : allNewPaymentMethods.paypal[0]?.productionNotifyURL || ""
                }
                cancel_url={
                  allNewPaymentMethods.paypal[0]?.developmentMode
                    ? allNewPaymentMethods.paypal[0]?.sandboxCancelURL || ""
                    : allNewPaymentMethods.paypal[0]?.productionCancelURL || ""
                }
                itemName={"NAME HERE"}
                reservationId={ReservationId}
              />
            )}
        </div>
      </section>
    </>
  );
}
export { PaymentDetailsPage };
